export default "__VITE_ASSET__9VMNku9s__"